<template>
  <v-container fluid justify-start :class="showGoBack ? '' : 'py-1'">
    <v-toolbar dark dense flat :color="toolbarColor">

      <app-back-button v-if="showGoBack" v-bind:color="toolbarColorDark" />

      <v-toolbar-title>
        <span :class="toolbarTitleClass"></span>
      </v-toolbar-title>

      <v-spacer />

      <template v-if="!isSmallDevice">

        <!-- Toolbar Buttons -->
        <v-toolbar-items>

          <!-- Edit Kiosk -->
          <v-btn :color="toolbarColorDark" @click="editKiosk()" :disabled="disableEditKiosk" :width="buttonWidthToolbar" class="ml-3 elevation-0">
            <span class="font-weight-medium">{{ getExpression('Button', 'EditKiosk') }}</span>
          </v-btn>

          <!-- Add User -->
          <!-- <v-btn v-if="isDomainManager || isAdmin"
            :color="toolbarColorDark"
            :width="buttonWidthToolbar"
            @click="addKioskManager()"
            :disabled="isLoadingResidents"
            class="ml-3 elevation-0"
            >
            <span class="font-weight-medium">{{ getExpression('Button', 'AddManager') }}</span>
          </v-btn> -->
        </v-toolbar-items>
      </template>

      <!-- Ellipsis Menu -->
      <template v-else>
        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              fab
              small
              :color="toolbarColorDark"
              class="elevation-0"
              v-bind="attrs"
              v-on="on"
              >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="editKiosk()" :disabled="disableEditKiosk">
              <v-list-item-title>
                <span class="font-weight-medium">{{ getExpression('Button', 'EditKiosk') }}</span> 
              </v-list-item-title>
            </v-list-item>
            <!-- <template v-if="isDomainManager || isAdmin">
              <v-list-item @click="addKioskManager()">
                <v-list-item-title>
                  <span class="font-weight-medium">{{ getExpression('Button', 'AddManager') }}</span> 
                </v-list-item-title>
              </v-list-item>
            </template> -->
          </v-list>
        </v-menu>
      </template>
    </v-toolbar>

    <!-- General Info -->
    <v-card class="pa-0">
      <v-row no-gutters>
        <v-col cols="12" sm="5">
        <general-info class="mb-1" />
        </v-col>
        <v-col cols="12" sm="7">
          <div :class="serialNumberContainerClass">
            <span :class="serialNumberClass">{{ activeKiosk.serialNumber }}</span>
            <template v-if="activeKiosk.domain !== null && isDomainManager || isAdmin">
              <div :class="domainOrgClass">
                <div>{{ domainName }}</div>
                <div>{{ organizationName }}</div>
              </div>
            </template>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <!-- Admin Stats -->
    <template v-if="isAdmin">
      <v-expansion-panels class="mt-2">
        <v-expansion-panel>
          <v-toolbar flat :color="toolbarColorDark" height="5"></v-toolbar>
          <v-expansion-panel-header class="py-0">
            <span><v-icon class="mr-2">update</v-icon>Kiosk Status</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>

            <v-divider class="mb-3" />

            <!-- Genie -->
            <template v-if="isGenie">
              <v-row no-gutters>
                <v-col cols="12" sm="3">
                  <v-list-item>
                    <v-list-item-content class="pa-0">
                      <v-list-item-title>
                        Last Synced
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <span v-if="isLoadingAdminStats">One moment...</span>
                        <app-date v-else :date="mediaSyncDate" defaultText='Never Synced' />
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-list-item>
                    <v-list-item-content class="pa-0">
                      <template v-if="isLoadingAdminStats">
                        <v-list-item-title class="mr-1">Update Level
                          <v-progress-circular :size="15" :width="2" :color="appColor_Progress" indeterminate class="ml-2" />
                        </v-list-item-title>
                      </template>
                      <v-list-item-title v-else>
                        <v-badge :content="`${updateLevel}`" inline :color="updateColor" class="mt-0">
                          <span class="mr-1">Update Level</span>
                        </v-badge>
                      </v-list-item-title>

                      <v-list-item-subtitle>
                        <span v-if="isLoadingAdminStats">One moment...</span>
                        <app-date v-else :date="updateInstallDate" defaultText='Never Updated' />
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </template>

            <!-- Abby -->
            <template v-else-if="isAbby">
              <v-row no-gutters>
                <v-col cols="12" sm="4">
                  <v-list-item>
                    <v-list-item-content class="pa-0">
                      <v-list-item-title>
                        Last Synced
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <span v-if="isLoadingAdminStats">One moment...</span>
                        <app-date v-else :date="mediaSyncDate" defaultText='Never Synced' />
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-list-item two-line>
                    <v-list-item-content class="pa-0">
                      <template v-if="isLoadingAdminStats">
                        <v-list-item-title class="mr-1">Activity Level
                          <v-progress-circular :size="15" :width="2" :color="appColor_Progress" indeterminate class="ml-2" />
                        </v-list-item-title>
                      </template>

                      <v-list-item-title v-else>
                        <v-badge :content="`${updateLevel}`" inline :color="updateColor" class="mt-0">
                          <span class="mr-1">Update Level</span>
                        </v-badge>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <span v-if="isLoadingAdminStats">One moment...</span>
                        <app-date v-else :date="updateInstallDate" defaultText='Never Updated' />
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-if="isLoadingAdminStats">
                        <span>One moment...</span>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-else>
                        {{ updateMessage }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-list-item two-line>
                    <v-list-item-content class="pa-0">
                      <template v-if="isLoadingAdminStats">
                        <v-list-item-title class="mr-1">Activity Level
                          <v-progress-circular :size="15" :width="2" :color="appColor_Progress" indeterminate class="ml-2" />
                        </v-list-item-title>
                      </template>
                      <v-list-item-title v-else>
                        <v-badge :content="`${activityLevel}`" inline :color="activityColor" class="mt-0">
                          <span class="mr-1">Activity Level</span>
                        </v-badge>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <span v-if="isLoadingAdminStats">One moment...</span>
                        <app-date v-else :date="activityInstallDate" defaultText='Never Updated' />
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-if="isLoadingAdminStats">
                        <span>One moment...</span>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-else>
                        {{ activityMessage }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>

    <!-- Residents Area -->
    <v-expansion-panels class="mt-2">
      <v-expansion-panel>
        <v-toolbar v-if="!isLoadingResidents" flat :color="appColor_ResidentLight" :height="5"></v-toolbar>
        <v-progress-linear v-else indeterminate :color="appColor_ResidentLight" :height="5"/>

        <v-expansion-panel-header>
          <v-icon large class="mr-3">people</v-icon>

          <v-card-text class="pa-0">
            <div :class="allResidentsHeaderClass">
              {{ `${getExpression('Heading', 'AllResidents')}` }}
              <template v-if="!isLoadingResidents" :class="allResidentsHeaderClass">
                <span>{{ `(${residentCount})` }}</span>
              </template>
              <span v-else class="ml-2">
                <v-progress-circular indeterminate :size="15" :width="2" />
              </span>
            </div>
            
            <div v-if="numNewResidentMessages > 0">
              <span class="mr-2">{{ `${getExpression('Label', 'NewMessages')}` }}</span>
              <span v-if="isLoadingResidents">
                <v-progress-circular indeterminate :size="15" :width="2" />
              </span>
              <v-chip v-else small dark :color="appColor_ResidentDark">{{ `${numNewResidentMessages}` }}</v-chip>
            </div>
          </v-card-text>
        </v-expansion-panel-header>

        <v-divider />

        <v-expansion-panel-content class="mt-2">

          <!-- Resident List -->
          <v-list-item-group v-for="(r, i) in residents" :key="r.id">
            <v-list-item @click="gotoResidentDashboard(r)" :three-line="isGenie" :disabled="isAbby && isLoadingKioskKeyNums">
              <!-- Avatar -->
              <v-list-item-action>
                <v-img width="60"
                  :src="r.picture !== null
                      ? r.picture
                      : imageUri_NoAvatar"
                  >
                </v-img>
              </v-list-item-action>

              <!-- Tombstone -->
              <v-list-item-content >
                <v-list-item-subtitle>
                  {{ r.name }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="mt-1">
                  <span v-html="getExpression('Label', 'KeyId')" class="mr-1"></span>
                  <v-progress-circular v-if="isLoadingKioskKeyNums" indeterminate :size="12" :width="2" />
                  <template v-else>
                    <b v-if="keyNums.length === 0">{{ getBeaconIdValue(r.bluetoothBeaconId) }}</b>
                    <b v-else>{{ getKeyNum(r.kioskKeyTagId) }}</b>
                  </template>
                </v-list-item-subtitle>

                <v-list-item-subtitle v-if="isGenie">
                  {{ getExpression('Label', 'NewMessages') }}
                  <v-chip small dark color="blue" class="ml-1">
                    <v-progress-circular v-if="isLoadingResidentSummaries" indeterminate :size="12" :width="2" />
                    <span v-else>{{ r.newMessages }}</span>
                  </v-chip>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="i < residents.length - 1" />
          </v-list-item-group>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Message Center -->
    <v-card v-if="isGenie && hasResidents" class="mt-2">
      <v-expansion-panels v-model="panel_MessageCenter" class="mt-2">
        <v-expansion-panel>
          <v-expansion-panel-header dense class="py-0" :color="headingColor_MessageCenter">
            <v-toolbar dense flat :color="headingColor_MessageCenter">
              <v-icon class="mr-3">message</v-icon>
              <v-toolbar-title :class="toolbarTitleClass">{{ getExpression('Heading', 'MessageCenter') }}</v-toolbar-title>
            </v-toolbar>
          </v-expansion-panel-header>

          <v-expansion-panel-content class="mt-2" >

            <dashboard-link
              v-if="isKioskManager"
              :linkText="getExpression('DashboardLink', 'SendMessageToResident')"
              :infoText="getExpression('DashboardInfo', 'SendMessageToResident')"
              :disabled="disableResidentMessageButton"
              @click="composeMessage()"
            />

            <v-divider v-if="isKioskManager" />

            <dashboard-link
              :linkText="geniegramLinkText"
              :infoText="getExpression('DashboardInfo', 'SendGeniegramToResidentContacts')"
              :disabled="!hasResidents"
              @click="gotoRoute('KioskEmailManager')"
              >
              <template v-slot:link-text>
                <span :style="appStyle_HyperLink" class="mr-2">{{ getExpression('DashboardLink', 'Send') }}</span>
                <img :src="imageUri_Geniegram" alt="" width="130" style="display: table-cell; vertical-align: bottom;"/>
                <span :style="appStyle_HyperLink" class="ml-2">{{ getExpression('DashboardLink', 'ToResidentContacts') }}</span>
              </template>

            </dashboard-link>

            <v-divider />

            <dashboard-link
              :linkText="getExpression('DashboardLink', 'ManageAllMessages')"
              :infoText="getExpression('DashboardInfo', 'ManageAllMessages')"
              :disabled="disableResidentMessageButton"
              @click="gotoRoute('MessageManager')"
            />

          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>

    <!-- Manage Kiosk -->
    <v-card class="mt-2">
      <v-expansion-panels v-model="panel_ManageKiosk" class="mt-2">
        <v-expansion-panel>
          <v-expansion-panel-header class="py-0" :color="headingColor_ManageKiosk">
            <v-toolbar dense flat :color="headingColor_ManageKiosk">
              <v-icon class="mr-3">computer</v-icon>
              <v-toolbar-title :class="toolbarTitleClass">{{ getExpression('Heading', 'ManageKiosk') }}</v-toolbar-title>
            </v-toolbar>
          </v-expansion-panel-header>

          <v-expansion-panel-content class="mt-2" >

            <dashboard-link
              :linkText="getExpression('DashboardLink', 'CommunityPlaylists')"
              :infoText="getExpression('DashboardInfo', 'CommunityPlaylists')"
              :disabled="isLoadingResidents"
              @click="gotoCommunityPlaylistManager()"
            />
            
            <!-- ABBY -->
            <template v-if="isAbby">
              <v-list>

                <v-divider v-if="isDomainManager || isAdmin" />

                <dashboard-link v-if="isDomainManager || isAdmin"
                  :linkText="getExpression('DashboardLink', 'AddKioskManager')"
                  :infoText="getExpression('DashboardInfo', 'AddKioskManager')"
                  @click="addKioskManager()"
                />
    
                <v-divider />

                <dashboard-link
                  :linkText="getExpression('DashboardLink', 'AllPlatformParticipants')"
                  :infoText="getExpression('DashboardInfo', 'AllPlatformParticipants')"
                  :disabled="isLoadingResidents"
                  @click="gotoRoute('AbbyKioskParticpants')"
                />

              </v-list>
            </template>

            <!-- GENIE -->
            <template v-if="isGenie">
              
              <v-divider/>

              <dashboard-link
                :linkText="getExpression('DashboardLink', 'KioskLibrary')"
                :infoText="getExpression('DashboardInfo', 'KioskLibrary')"
                @click="gotoRoute('KioskMediaManager')"
              />

              <v-divider/>

              <dashboard-link v-if="isDomainManager || isAdmin"
                :linkText="getExpression('DashboardLink', 'AddKioskManager')"
                :infoText="getExpression('DashboardInfo', 'AddKioskManager')"
                @click="addKioskManager()"
              />  

              <v-divider  v-if="isDomainManager || isAdmin" />

              <dashboard-link
                :linkText="getExpression('DashboardLink', 'AllKioskManagers')"
                :infoText="getExpression('DashboardInfo', 'AllKioskManagers')"
                :disabled="isLoadingResidents"
                @click="gotoRoute('GenieKioskManagers')"
              />

            </template>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>

    <!-- Manage Residents and Contacts / Family Facilitators -->
    <v-card class="mt-2">
      <v-expansion-panels v-model="panel_ResidentsAndContacts" class="mt-2">
        <v-expansion-panel>
          <v-expansion-panel-header class="py-0" :color="headingColor_ResidentsAndContacts">
            <v-toolbar dense flat :color="headingColor_ResidentsAndContacts">
              <v-icon class="mr-3">people</v-icon>
              <v-toolbar-title v-if="isAbby" :class="toolbarTitleClass">{{ getExpression('Heading', 'ManageResidentsAndFamilyFacilitators') }}</v-toolbar-title>
              <v-toolbar-title v-else-if="isGenie" :class="toolbarTitleClass">{{ getExpression('Heading', 'ManageResidentsAndContacts') }}</v-toolbar-title>
            </v-toolbar>
          </v-expansion-panel-header>

          <v-expansion-panel-content class="mt-2" >

            <dashboard-link
              :linkText="getExpression('DashboardLink', 'AddResident')"
              :infoText="getExpression('DashboardInfo', 'AddResident')"
              :disabled="isLoadingResidents || isLoadingKioskKeyNums"
              @click="addResident()"
            />

            <!-- ABBY -->
            <template v-if="isAbby && hasResidents">

              <v-divider />

              <dashboard-link
                :linkText="getExpression('DashboardLink', 'AddFamilyFacilitator')"
                :infoText="getExpression('DashboardInfo', 'AddFamilyFacilitator')"
                :disabled="isLoadingResidents"
                @click="addFamilyFacilitator()"
              />

            </template>
            
            <!-- GENIE -->
            <template v-if="isGenie && hasResidents">

              <v-divider />

              <dashboard-link
                :linkText="getExpression('DashboardLink', 'AddResidentContact')"
                :infoText="getExpression('DashboardInfo', 'AddResidentContact')"
                :disabled="isLoadingResidents"
                @click="addContact()"
              />

              <v-divider />

              <dashboard-link
                :linkText="getExpression('DashboardLink', 'AllResidentContacts')"
                :infoText="getExpression('DashboardInfo', 'AllResidentContacts')"
                :disabled="isLoadingResidents"
                @click="gotoRoute('GenieKioskResidentContacts')"
              />
            </template>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>

  </v-container>
</template>

<script>
import appService from '@/app.service.js'
import { mapGetters } from 'vuex'
import { AppColor, AppStyle, KioskTypeId, UserRole, ImageUri, LanguageId, AddContactContext, KioskDashboardHeaderColor } from '@/config.js'
import GeneralInfo from '@/components/KioskDashboard/GeneralInfo'
import AppBackButton from '@/components/App/AppBackButton'
import DashboardLink from '@/components/KioskDashboard/DashboardLink'
import AppDate from '@/components/App/AppDate'

export default {
  name: 'KioskDashboard',
  components: {
    GeneralInfo,
    AppBackButton,
    DashboardLink,
    AppDate
  },
  data() {
    return {
      
      // colors
      appColor_Light: AppColor.Light,
      appColor_Progress: AppColor.Progress,
      appColor_AbbyLight: AppColor.KioskTypeAbbyLight,
      appColor_Abby: AppColor.KioskTypeAbby,
      appColor_GenieLight: AppColor.KioskTypeGenieLight,
      appColor_Genie: AppColor.KioskTypeGenie,
      appColor_ResidentLight: AppColor.ResidentLight,
      appColor_ResidentDark: AppColor.ResidentDark,
      appColor_ResidentExtraExtraLight: AppColor.ResidentExtraExtraLight,
      appColor_Warning: AppColor.Warning,
      appColor_Error: AppColor.Error,

      headingColor_MessageCenter: KioskDashboardHeaderColor.MessageCenter,
      headingColor_ManageKiosk: KioskDashboardHeaderColor.ManageKiosk,
      headingColor_ResidentsAndContacts: KioskDashboardHeaderColor.ResidentsAndContacts,

      // style
      appStyle_HyperLink: AppStyle.DashboardLink,
      appStyle_HyperLinkDisabled: AppStyle.DashboardLinkDisabled,

      // kiosk types
      kioskTypeId_Abby: KioskTypeId.Abby,
      kioskTypeId_Genie: KioskTypeId.Genie,

      // uri
      imageUri_NoAvatar: ImageUri.NoAvatar,
      imageUri_Geniegram: ImageUri.Geniegram,
      
      // roles
      role_Admin: UserRole.Admin,
      role_Manager: UserRole.Manager,

      // dashboard contexts
      addContactContext_KioskDashboard: AddContactContext.KioskDashboard,
      addContactContext_KioskDashboardResidentPanel: AddContactContext.KioskDashboardResidentPanel,      
      addContactContext_ResidentDashboard: AddContactContext.ResidentDashboard,
      
      // stats
      mediaSyncDate: null,
      updateLevel: null,
      updateInstallDate: null,
      activityLevel: null,
      activityInstallDate: null,
      maxUpdateLevel: null,
      maxActivityLevel: null,

      // kiosk
      numNewKioskMessages: 0,
      numNewResidentMessages: 0,

      // residents
      residents: [],

      isLoading: true,
      isLoadingResidents: true,
      isLoadingResidentSummaries: true,
      isLoadingKioskKeyNums: true,
      isLoadingAdminStats: true,

      // panels
      panel_MessageCenter: null,
      panel_ManageKiosk: null,
      panel_ResidentsAndContacts: null,

      allResidentsHeaderClass: 'font-weight-regular text-h6'
    }
  },
  computed: {
    ...mapGetters([
        'profile',
        'languages',
        'kioskResidents',
        'contacts',
        'kioskKeyNums',
        'contactCount',
        'activeKiosk',
        'isAdmin',
        'kioskCount',
        'isKioskManager',
        'isDomainManager',
        'isResidentManager',
        'currentRoute']),
    title () {
      const defaultTitle = 'Kiosk Dashboard'
      if (this.isNullOrUndefined(this.activeKiosk)) return defaultTitle

      if (this.isGenie) {
        return 'Genie Kiosk Dashboard'
      } else if (this.isAbby) {
        return 'Abby Kiosk Dashboard'
      } else return defaultTitle
    },
    toolbarColor () {
      return this.isAbby 
        ? this.appColor_AbbyLight
        : this.appColor_GenieLight
    },
    toolbarColorDark () {
      return this.isAbby 
        ? this.appColor_Abby
        : this.appColor_Genie
    },
    languagedLanguages () {
      const self = this
      return this.languages.map(l => { return {
        id: l.id,
        description: self.getExpression('Language', l.description)
      }})
    },
    languageId () {
      return this.profile.languageId
    },
    contactUsers () {
      return this.contacts ?? []
    },
    keyNums () {
      return this.kioskKeyNums ?? []
    },
    domainName () {
      return this.activeKiosk.domain !== null
        ? this.activeKiosk.domain.name
        : null
    },
    organizationName () {
      return this.activeKiosk.domain !== null
        ? this.activeKiosk.domain.organizationName
        : null
    },
    isGenie () {
      if (this.isNullOrUndefined(this.activeKiosk)) return false
      return this.activeKiosk.typeId === this.kioskTypeId_Genie
    },
    isAbby () {
      if (this.isNullOrUndefined(this.activeKiosk)) return false
      return this.activeKiosk.typeId === this.kioskTypeId_Abby
    },
    hasMultipleKiosks () {
      if (!this.isValidSession) return false
      return this.kioskCount > 1
    },
    hasResidents () {
      if (this.isNullOrUndefined(this.activeKiosk)) return false
      return this.activeKiosk.hasResidents
    },
    residentCount () {
      if (this.isNullOrUndefined(this.kioskResidents)) return 0
      return this.kioskResidents.length
    },
    disableChangePicture () {
      return this.isGenie
    },   
    showGoBack () {
      return this.hasMultipleKiosks || this.isAdmin
    },
    isUpdateRequired () {
      return this.maxUpdateLevel > this.updateLevel
    },
    isActivityRequired () {
      return this.maxActivityLevel > this.activityLevel
    },
    updateColor () {
      if (this.isUpdateRequired) {
        return 'red darken-1'
      } else {
        return 'green'
      }
    },
    activityColor () {
      if (this.isActivityRequired) {
        return 'red darken-1'
      } else {
        return 'green'
      }
    },
    updateMessage () {
      const updatesBehind = this.maxUpdateLevel - this.updateLevel
      const updateDesc = updatesBehind > 1
        ? 'updates'
        : 'update'

      return (this.isUpdateRequired)
        ? `${updatesBehind} ${updateDesc} behind`
        : 'Up to date'
    },
    activityMessage () {
      const activitiesBehind = this.maxActivityLevel - this.activityLevel
      const activityDesc = activitiesBehind > 1
        ? 'activities'
        : 'activity'
      return (this.isActivityRequired)
        ? `${activitiesBehind} ${activityDesc} behind`
        : 'Up to date'
    },
    functionalRoles () {
      // allowable roles for adding users
      var roles = []
      if (this.isGenie) {
        roles = [
          this.getExpression('FunctionalRole', 'FamilyFacilitator'),
          this.getExpression('FunctionalRole', 'VirtualVisitor')]
      } else if (this.isAbby) {
        roles =  [
          this.getExpression('FunctionalRole', 'FamilyFacilitator')]
      }
      if (this.isDomainManager || this.isAdmin) {
        roles.unshift(this.getExpression('FunctionalRole', 'KioskManager'))
      }
      return roles
    },
    geniegramLinkText () {
      return `${this.getExpression('DashboardLink', 'Send')} GENIEGRAM ${this.getExpression('DashboardLink', 'ToResidentContacts')}`
    },
    disableEditKiosk () {
      return this.isAbby
        ? false
        : this.isLoading
    },
    disableResidentMessageButton () {
      return !this.hasResidents || this.isLoadingResidents
    },
    toolbarTitleClass () {
      return this.isSmallDevice
        ? 'font-weight-light body-1 black--text'
        : 'font-weight-light black--text'
    },
    buttonWidthToolbar () {
      return this.languageId === LanguageId.English
        ? 150
        : 210
    },
    serialNumberContainerClass () {
      return this.isSmallDevice
        ? 'ml-2'
        : 'ml-2 mt-2'
    },
    serialNumberClass () {
      return this.isSmallDevice
        ? 'text-h4 font-weight-bold grey--text text--darken-2 ml-2 mt-0'
        : 'text-h3 font-weight-bold grey--text text--darken-2'
    },
    domainOrgClass () {
      return this.isSmallDevice
        ? 'subtitle-2 font-weight-light grey--text ml-2 pb-2'
        : 'subtitle-2 font-weight-light grey--text pa-0'
    }
  },
  methods: {
    loadData () {
      const self = this
      if (!self.isValidSession) return
      if (self.activeKiosk === null) return

      self.isLoading = true
      self.isLoadingAdminStats = true
      self.isLoadingResidents = true
      self.$store.dispatch('clearActiveResident')
      self.loadResidentData().then(() => {
        self.updateKiosk()
        self.loadKioskKeyNums().then(() => {
          self.loadContactUsers().then(() => {
            self.loadAdminStats().then(() => {
              self.isLoadingAdminStats = false
              self.isLoading = false
            })
          })
        })
      })
    },

    loadResidentData () {
      return new Promise(resolve => {
        const self = this
        self.isLoadingResidentSummaries = true
        self.loadResidents().then(() => {
          self.isLoadingResidents = false
          self.loadResidentSummaries().then(() => {
            self.isLoadingResidentSummaries = false
            self.loadResidentPictures()
            resolve()
          })
        })
      })
    },

    updateKiosk () {
      const self = this
      const kioskId = self.activeKiosk.id
      const hasResidents = self.residents.length > 0
      self.$store.dispatch('updateKiosk', {
        kiosk: {
          id: kioskId,
          hasResidents: hasResidents
        }
      })
    },

    loadResidents () {
      const self = this
      return new Promise((resolve) => {
        if (self.kioskResidents === null) {
          appService.getResidentsForLoginByKiosk(self.profile, self.activeKiosk.id).then(data => {
            if (data.errorSeverity !== null) {
              self.handleError(data)
            } else {
              self.residents = data.residents
              self.initResidents()
              resolve()
            }
          }).catch(e => { self.handleCriticalError(e) })
        } else {
          self.residents = self.kioskResidents
          self.syncResidentPictures()
          resolve()
        }
      })
    },

    loadResidentSummaries () {
      const self = this
      return new Promise((resolve) => {
        appService.getKioskDashboardResidentSummaries(self.activeKiosk.id).then(data => {
          if (data.errorSeverity !== null) {
            self.handleError(data)
          } else {
            const summaryResidents = data.residents
            var newMessageCount = 0
            summaryResidents.forEach(dr => {
              const residents = self.residents.filter(r => r.id === dr.id)
              const resident = residents.length > 0
                ? residents[0]
                : null
              if (resident !== null) {
                resident.newMessages = dr.newMessages
                newMessageCount = newMessageCount + dr.newMessages
              }
            })
            self.numNewResidentMessages = newMessageCount
            resolve()
          }
        }).catch(e => { self.handleCriticalError(e) })
      })
    },

    loadResidentPictures () {
      const self = this
      return new Promise((resolve) => {
        if (self.residents
          .filter(r => r.picture?.length === 0).length === 0) return

        const ids = self.residents.map(r => r.id)
        appService.getResidentPicturesByIds(ids).then((data) => {
          self.residentPictures = data.pictures
          self.populateResidentPictures().then(() => {
            resolve()
          })
        }).catch(e => { self.handleCriticalError(e) })
      })
    },

    populateResidentPictures () {
      const self = this
      return new Promise((resolve) => {
        self.residents.forEach((r) => {
          r.picture = self.getResidentPicture(r.id)
        })
        resolve()
      })
    },

    getResidentPicture (id) {
      if (this.residentPictures === null) return ''
      const self = this
      var pictures = self.residentPictures.filter((value) => {
        return value.residentId === id
      })
      if (pictures.length > 0) {
        return pictures[0].base64
      }
      return ImageUri.NoAvatar
    },

    loadContactUsers () {
      return new Promise((resolve) => {
        const self = this
        const profileModel = Object.assign({}, self.profile)

        // simluate a KM with 1 kiosk
        profileModel.role = self.role_Manager
        profileModel.kioskIds = [self.activeKiosk.id]
        profileModel.residentIds = null
        profileModel.facilityIds = null
        
        const allowedRoles = [
          self.getExpression('FunctionalRole', 'KioskManager', LanguageId.English),
          self.getExpression('FunctionalRole', 'DomainManager', LanguageId.English)
        ]
        if (self.contacts === null) {
          profileModel.context = 'kiosk-contact'
          appService.getUsersForManager(profileModel).then(data => {
            if (data.errorSeverity !== null) {
              self.handleError(data)
            } else {
              const contacts = data.users
                .filter(u => allowedRoles.includes(u.functionalRole))
                .map(u => { return {
                  id: u.id,
                  name: u.name,
                  email: u.email,
                  picture: u.picture !== null
                    ? u.picture
                    : self.imageUri_NoAvatar
                }})
                self.$store.dispatch('storeContacts', { contacts })
                self.contacts.unshift({ id: '', name: self.getExpression('Label', 'NoContact'), email: null })
            }
            resolve()
          }).catch(e => { self.handleCriticalError(e) })
        } else resolve()
      })
    },
	
    loadKioskKeyNums () {
      return new Promise((resolve) => {
        const self = this
        self.isLoadingKioskKeyNums = true

        if (self.kioskKeyNums === null) {
          appService.getKioskKeyTags(self.activeKiosk.id).then(data => {
            self.isLoadingKioskKeyNums = false
            if (data.errorSeverity !== null) {
              self.handleError(data)
            } else {
              const kioskKeyNums = data.keyTags
                .filter(kt => kt.keyNum > 0)
                .map(kt => { return {
                  id: kt.id,
                  keyNum: kt.keyNum,
                  kioskId: kt.kioskId,
                  residentId: kt.residentId
                }})
                self.$store.dispatch('storeKioskKeyNums', { kioskKeyNums })
            }
            resolve()
          }).catch(e => { self.handleCriticalError(e) })
        } else {
          self.isLoadingKioskKeyNums = false
          resolve()
        }
      })
    },

    loadAdminStats () {
      const self = this
      return new Promise((resolve) => {
        if (self.isAdmin) {

          appService.getKioskDashboardGeneralStats(self.activeKiosk.id).then(data => {
            if (data.errorSeverity > 0) {
              self.handleError(data)
            } else {
              self.mediaSyncDate = data.mediaSyncDate
              self.updateLevel = data.updateLevel
              self.updateInstallDate = data.updateInstallDate
              self.activityLevel = data.activityLevel
              self.activityInstallDate = data.activityInstallDate
              self.maxUpdateLevel = data.maxUpdateLevel
              self.maxActivityLevel = data.maxActivityLevel
            }
            resolve()
          }).catch(e => { self.handleCriticalError(e) })
        } else { 
          appService.getKioskDashboardManagerStats(self.activeKiosk.id, self.profile.id).then(data => {
            if (data.errorSeverity > 0) {
              self.handleError(data)
            } else {
              self.numNewKioskMessages = data.numNewKioskMessages
            }
            resolve() 
          })
        }        
      })
    },

    initResidents () {
      const self = this
      const kioskResidents = self.residents
      // initialize properties that don't yet exist (i.e. undefined)
      // and sync the pictures
      kioskResidents.forEach(kr => {
        const resident = self.residents.filter(r => r.id === kr.id)[0]
        kr.newMessages = null
        kr.picture = resident.pictureBase64
      })
      self.$store.dispatch('storeKioskResidents', { kioskResidents })
    },

    syncResidentPictures () {
      // unfortunately the picture properties of each collection have different names
      // one is "pictureBase64" and the other is "picture"
      // give the residents collection the same pictures as the kioskResidents
      const self = this
      self.kioskResidents.forEach(kr => {
        const resident = self.residents.filter(r => r.id === kr.id)[0]
        resident.pictureBase64 = kr.picture
      })
    },

    gotoRoute (name) {
      this.$store.dispatch('pushRoute', { name: name })
      this.$router.push({ name: name})
    },

    gotoCommunityPlaylistManager () {
      if (this.isAbby) this.gotoRoute('AbbyKioskProfileManager')
      else if (this.isGenie) this.gotoRoute('KioskPlaylistManager')
    },

    editKiosk () {
      this.$kiosk.edit({
        contactUsers: this.contactUsers
      })
    },

    addContact () {
      const self = this

      const addResidents = self.residents.map(r => { return {
        id: r.id,
        name: r.name,
        kioskTypeId: r.kioskTypeId,
        picture: null
      }})

      self.$user.add({
        context: self.addContactContext_KioskDashboardResidentPanel,
        functionalRoles: self.functionalRoles.filter(fr => fr !== self.getExpression('FunctionalRole', 'KioskManager')),
        residents: addResidents,
        onSave: () => {
          self.$store.dispatch('clearKioskContacts')
          self.loadContactUsers()
        }
      })
    },

    addFamilyFacilitator () {
      const self = this

      const addResidents = self.residents.map(r => { return {
        id: r.id,
        name: r.name,
        kioskTypeId: r.kioskTypeId,
        picture: null
      }})

      self.$user.add({
        context: self.addContactContext_KioskDashboardResidentPanel,
        functionalRoles: [self.getExpression('FunctionalRole', 'FamilyFacilitator')],
        residents: addResidents
      })
    },

    addKioskManager () {
      const self = this

      self.$user.add({
        context: self.addContactContext_KioskDashboard,
        functionalRoles: [this.getExpression('FunctionalRole', 'KioskManager')],
        onSave: () => {
          self.$store.dispatch('clearKioskContacts')
          self.loadContactUsers()
        }
      })
    },

    addResident () {
      const self = this

      self.$resident.add({
        context: self.addContactContext_KioskDashboardResidentPanel,
        kioskTypeId: self.activeKiosk.typeId,
        addContactText: self.isAbby 
          ? self.getExpression('Label', 'AddOptionalFamilyFacilitator')
          : self.getExpression('Label', 'AddOptionalResidentContact'),
        onAdd: (resident) => {
          self.isLoadingResidents = true
          appService.getResidentExtended(resident.id).then(data => {
            if (data.errorSeverity !== null) {
              self.handleError(data)
            } else {
              var newResident = data.resident
              if (self.residents.filter(r => r.id === newResident.id).length === 0) {
                newResident.newMessages = 0
                newResident.picture = self.imageUri_NoAvatar
                self.residents.unshift(newResident)
                const kioskResidents = self.residents
                self.$store.dispatch('clearKioskResidents')
                self.$store.dispatch('storeKioskResidents', { kioskResidents })
                if (newResident.kioskKeyTagId > 0) {
                  const kioskKeyNum = { id: newResident.kioskKeyTagId, residentId: newResident.id }
                  self.$store.dispatch('updateKioskKeyNum', { kioskKeyNum })
                }
                self.updateKiosk()
              }
              self.isLoadingResidents = false 
            }
          })
        }
      })
    },

    composeMessage () {
      const self = this
      const messageResidents = self.residents.map(r => { return {
        id: r.id,
        name: r.name,
        kioskTypeId: r.kioskTypeId,
        picture: null
      }})

      self.$message.compose({
        residents: messageResidents,
        onSend: (residentIds) => {
          self.residents.forEach(r => {
            if (residentIds.includes(r.id)) {
              r.newMessages++
            }
          })
        }
      })
    },

    gotoResidentDashboard (resident) {
      const activeResident = this.residents.filter(r => r.id === resident.id)[0]
      this.$store.dispatch('clearActiveResident')
      this.$store.dispatch('setActiveResident', { activeResident: activeResident })
      this.$store.dispatch('pushRoute', { name: 'ResidentDashboard' })
      this.$router.push({ name: 'ResidentDashboard' })
    },

    getBeaconIdValue (beaconId) {
      if (this.isNullOrUndefined(beaconId))
        return this.getExpression('Label', 'NoneAssigned')

      return beaconId
    },

    getKeyNum (kioskKeyTagId) {
      if (this.isNullOrUndefined(kioskKeyTagId))
        return this.getExpression('Label', 'NoneAssigned')

      const self = this
      const keyNums = self.kioskKeyNums.filter(kn => kn.id === kioskKeyTagId)

      return keyNums.length > 0
        ? keyNums[0].keyNum
        : self.getExpression('Label', 'NoneAssigned')
    },

    handleError (result) {
      this.$error.show({
        title: result.errorSeverity === 0
          ? this.getExpression('FormTitle', 'ValidationFailed')
          : this.getExpression('FormTitle', 'InternalError'),      
        text: result.errorMessage,
        severity: result.errorSeverity
      })
    }
  },
  created() {
    this.loadData()
  },
  watch: {
    isValidSession(val) {
      if (val === null) return
      this.loadData()
    }
  }
}
</script>